var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function debounce(fn, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}
__name(debounce, "debounce");
const initShowerReading = /* @__PURE__ */ __name(($el) => {
  const cardContainer = [...$el.querySelectorAll(".js-card-container")];
  const cardImageContainer = [...$el.querySelectorAll(".js-card-image-container")];
  const cardResetReading = [...$el.querySelectorAll(".js-reset-reading")];
  const showerTitle = $el.querySelector(".js-shower-title");
  const exploreTitle = $el.querySelector(".js-explore-title");
  const btnReading = $el.querySelector(".js-button-reading");
  const showerReadingContainer = $el.querySelector(".js-shower-reading-container");
  const deckSliderContainer = $el.querySelector(".js-slider-container");
  const mobileShare = [...$el.querySelectorAll(".js-mobile-share")];
  const ogTitle = document.querySelector('meta[property="og:title"]');
  const ogDescription = document.querySelector('meta[property="og:description"]');
  const isMobile = window.matchMedia("(max-width: 768px)");
  let ogImage = document.querySelector('meta[property="og:image"]');
  if (!showerTitle || !showerTitle || !btnReading || !(btnReading instanceof HTMLButtonElement) || !showerReadingContainer || !exploreTitle || !deckSliderContainer) {
    return;
  }
  if (!ogImage) {
    ogImage = document.createElement("meta");
    ogImage.setAttribute("property", "og:image");
    ogImage.setAttribute("content", "");
    document.head.appendChild(ogImage);
  }
  const setShowerReadingMinHeight = /* @__PURE__ */ __name(() => {
    if (!(showerReadingContainer instanceof HTMLElement) || !(cardImageContainer[0] instanceof HTMLElement)) {
      return;
    }
    const firstImage = cardImageContainer[0];
    const height = firstImage.offsetHeight;
    showerReadingContainer.style.minHeight = `${height * 1.4}px`;
  }, "setShowerReadingMinHeight");
  setShowerReadingMinHeight();
  const angles = Array.from({ length: cardContainer.length }, (_, i) => -15 + i * 3);
  let lowestZIndexElement = null;
  const shuffledAngles = [...angles].sort(() => Math.random() - 0.5);
  function animationSettings(direction, duration = 400) {
    const animationSettings2 = {
      duration,
      fill: "forwards",
      direction: direction === "reverse" ? "reverse" : "normal",
      easing: "ease-in-out"
    };
    return animationSettings2;
  }
  __name(animationSettings, "animationSettings");
  const headerTreatment = /* @__PURE__ */ __name((direction) => {
    if (showerTitle instanceof HTMLElement && showerReadingContainer instanceof HTMLElement && deckSliderContainer instanceof HTMLElement) {
      const showerHeaderHeight = btnReading.offsetHeight + showerTitle.offsetHeight;
      const headerKeyframes = [
        { opacity: "1", transform: "translateY(0)" },
        { opacity: "0", transform: `translateY(-${showerHeaderHeight}px)` }
      ];
      const keyframes = [{ transform: "translateY(0)" }, { transform: `translateY(-${showerHeaderHeight}px)` }];
      showerTitle.animate(headerKeyframes, animationSettings(direction));
      btnReading.animate(headerKeyframes, animationSettings(direction));
      showerReadingContainer.animate(keyframes, animationSettings(direction));
      deckSliderContainer.animate(keyframes, animationSettings(direction));
      exploreTitle.animate(keyframes, animationSettings(direction));
    }
  }, "headerTreatment");
  const cardsTreatment = /* @__PURE__ */ __name(() => {
    const zIndexes = Array.from({ length: cardContainer.length }, (_, i) => i + 1).sort(() => Math.random() - 0.5);
    cardContainer.forEach((card, i) => {
      if (!(card instanceof HTMLElement)) {
        return;
      }
      const zIndex = zIndexes[i];
      card.style.zIndex = zIndex.toString();
      card.classList.remove("opacity-0", "hidden");
      card.animate([{ opacity: "1" }, { opacity: "1" }], animationSettings("normal"));
      if (zIndex === 5) {
        lowestZIndexElement = card;
        if (ogTitle && ogTitle instanceof HTMLMetaElement) {
          ogTitle.content = card.querySelector(".js-card-title")?.textContent?.trim() || "";
        }
        if (ogDescription && ogDescription instanceof HTMLMetaElement) {
          ogDescription.content = card.querySelector(".js-card-description")?.textContent?.trim() || "";
        }
        if (ogImage && ogImage instanceof HTMLMetaElement) {
          ogImage.content = card.querySelector(".js-card-image-container")?.getAttribute("data-social-image").split("?")[0] || "";
        }
      } else if (zIndex === 9) {
        card.querySelector(".js-card-image-container")?.classList.add("rotate-none");
      } else {
        if (![...card.classList].some((cls) => cls.startsWith("delay-"))) {
          card.classList.add(`delay-${zIndex * 10}`);
        }
      }
    });
    cardImageContainer.forEach((image, i) => {
      if (!(image instanceof HTMLElement)) return;
      const angle = shuffledAngles[i % shuffledAngles.length];
      const parentCard = image.closest(".js-card-container");
      image.classList.remove("rotate-none");
      image.animate([{ transform: `rotate(0deg)` }, { transform: `rotate(${angle}deg)` }], animationSettings("normal"));
      if (parentCard && parentCard instanceof HTMLElement && parentCard.style.zIndex === "9") {
        image.classList.add("rotate-none");
        image.animate([{ transform: `rotate(${angle}deg)` }, { transform: `rotate(0deg)` }], animationSettings("normal"));
      }
    });
  }, "cardsTreatment");
  const getNCards = /* @__PURE__ */ __name((n, top) => cardContainer.filter((el) => el instanceof HTMLElement).sort((a, b) => {
    const zA = parseInt(a.style.zIndex || "0", 10);
    const zB = parseInt(b.style.zIndex || "0", 10);
    return top ? zB - zA : zA - zB;
  }).slice(0, n), "getNCards");
  const displaySelectedCard = /* @__PURE__ */ __name((direction) => {
    if (!lowestZIndexElement) return;
    const lowestZIndexElementImage = lowestZIndexElement.querySelector(".js-card-image-container");
    cardImageContainer.forEach((image) => {
      if (lowestZIndexElementImage !== image) {
        image.animate([{ opacity: "1" }, { opacity: "0" }], animationSettings(direction, 10));
      }
    });
    const content = lowestZIndexElement.querySelector(".js-card-content-container");
    if (content instanceof HTMLElement) {
      content.animate(
        [
          { opacity: "0", width: "0" },
          { opacity: "1", width: "100%" }
        ],
        animationSettings(direction)
      );
    }
    if (direction === "normal") {
      lowestZIndexElement.style.zIndex = "9";
      lowestZIndexElement.style.position = "relative";
      lowestZIndexElementImage.parentElement.classList.add("gap-10", "md:gap-[68px]");
    } else {
      lowestZIndexElement.style.position = "absolute";
      lowestZIndexElementImage.parentElement.classList.remove("gap-10", "md:gap-[68px]");
    }
  }, "displaySelectedCard");
  const animateTopCardsSequentially = /* @__PURE__ */ __name(async (topCards) => {
    for (const card of topCards) {
      await new Promise((resolve) => {
        const image = card.querySelector(".js-card-image-container");
        if (!(image instanceof HTMLElement)) {
          resolve();
          return;
        }
        const initialTransform = getComputedStyle(image).transform;
        let rotateDeg = 0;
        if (initialTransform && initialTransform !== "none") {
          const match = initialTransform.match(/matrix\(([^)]+)\)/);
          if (match) {
            const [a, b] = match[1].split(", ").map(parseFloat);
            rotateDeg = Math.round(Math.atan2(b, a) * (180 / Math.PI));
          }
        }
        const magnitude = 50 + Math.floor(Math.random() * 6) * 10;
        const direction = (Math.random() > 0.5 ? 1 : -1) * magnitude;
        image.animate(
          [{ transform: `translateX(0) rotate(${rotateDeg}deg)` }, { transform: `translateX(${direction}px) rotate(0deg)` }],
          animationSettings("normal", 150)
        ).onfinish = () => {
          image.animate(
            [{ transform: `translateX(${direction}px) rotate(0deg)` }, { transform: `translateX(0) rotate(0deg)` }],
            animationSettings("normal", 150)
          ).onfinish = () => {
            card.style.zIndex = "1";
            card.style.top = "0";
            resolve();
          };
        };
      });
    }
  }, "animateTopCardsSequentially");
  const animateTopCardsInPairs = /* @__PURE__ */ __name(async (topCards) => {
    const pairs = [];
    for (let i = 0; i < topCards.length; i += 2) {
      pairs.push(topCards.slice(i, i + 2));
    }
    for (const pair of pairs) {
      await Promise.all(
        pair.map((card) => {
          return new Promise((resolve) => {
            const image = card.querySelector(".js-card-image-container");
            if (!(image instanceof HTMLElement)) {
              resolve();
              return;
            }
            const initialTransform = getComputedStyle(image).transform;
            let rotateDeg = 0;
            if (initialTransform && initialTransform !== "none") {
              const match = initialTransform.match(/matrix\(([^)]+)\)/);
              if (match) {
                const [a, b] = match[1].split(", ").map(parseFloat);
                rotateDeg = Math.round(Math.atan2(b, a) * (180 / Math.PI));
              }
            }
            const magnitude = 50 + Math.floor(Math.random() * 12) * 10;
            const direction = (Math.random() > 0.5 ? 1 : -1) * magnitude;
            image.animate(
              [
                { transform: `translateX(0px) rotate(${rotateDeg}deg)` },
                { transform: `translateX(${direction}px) rotate(0deg)` }
              ],
              animationSettings("normal", 250)
            ).onfinish = () => {
              image.animate(
                [{ transform: `translateX(${direction}px) rotate(0deg)` }, { transform: `translateX(0px) rotate(0deg)` }],
                animationSettings("normal", 250)
              ).onfinish = () => {
                card.animate([{ opacity: "1" }, { opacity: "0" }], animationSettings("normal")).onfinish = () => {
                  card.style.zIndex = "1";
                  resolve();
                };
              };
            };
          });
        })
      );
    }
  }, "animateTopCardsInPairs");
  btnReading.addEventListener("click", async () => {
    headerTreatment("normal");
    const topCards = getNCards(4, true);
    const bottomCards = getNCards(4, false);
    if (lowestZIndexElement) {
      const image = lowestZIndexElement.querySelector(".js-card-image-container");
      if (image instanceof HTMLElement) {
        image.animate([{ transform: "rotate(0deg)" }, { transform: "rotate(0deg)" }], animationSettings("normal"));
        image.style.transform = "rotate(0deg)";
      }
    }
    bottomCards.forEach((card) => {
      if (!(card instanceof HTMLElement)) return;
      card.querySelector(".js-card-image-container")?.classList.add("rotate-none");
      card.classList.add("opacity-0", "hidden");
      card.style.zIndex = "1";
    });
    await animateTopCardsSequentially(topCards);
    displaySelectedCard("normal");
    showerReadingContainer.classList.add("step-2");
  });
  const debouncedSetMinHeight = debounce(setShowerReadingMinHeight, 150);
  window.addEventListener("resize", debouncedSetMinHeight);
  cardsTreatment();
  cardResetReading.forEach((cardReset) => {
    if (!(cardReset instanceof HTMLAnchorElement)) return;
    cardReset.addEventListener("click", (e) => {
      e.preventDefault();
      headerTreatment("reverse");
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      setTimeout(() => {
        displaySelectedCard("reverse");
        showerReadingContainer.classList.remove("step-2");
        cardsTreatment();
      }, 400);
    });
  });
  async function shareImage(imageUrl) {
    const fetchedImage = await fetch(imageUrl);
    const blobImage = await fetchedImage.blob();
    const fileName = imageUrl.split("/").pop();
    const filesArray = [
      new File([blobImage], fileName, {
        type: "image/png",
        lastModified: Date.now()
      })
    ];
    const shareData = {
      title: fileName,
      files: filesArray,
      url: window.location.href
    };
    if (navigator.canShare && navigator.canShare(shareData)) {
      await navigator.share(shareData);
    }
  }
  __name(shareImage, "shareImage");
  mobileShare.forEach((shareFileButton) => {
    shareFileButton.addEventListener("click", (e) => {
      e.preventDefault();
      const img = lowestZIndexElement.querySelector(".js-card-image-container")?.getAttribute("data-social-image");
      const cleanImg = img ? img.split("?")[0] : "";
      shareImage(cleanImg).catch((err) => {
        console.error("Error sharing image:", err);
      });
    });
  });
}, "initShowerReading");
window._sections["initShowerReading"] = initShowerReading;
